import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchLatestJobList } from "./LatestJobListAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchLatestJobListAsync = createAsyncThunk(
  "LatestJobList/fetch",
  async (_, { rejectWithValue }) => {
    try { 
      const data = await fetchLatestJobList();

      const resp = data?.response?.data;
      if (!resp) {
        throw new Error("Invalid response structure");
      }
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const LatestJobListSlice = createSlice({
  name: "LatestJobList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLatestJobListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLatestJobListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("data", action.payload);
        state.error = null;
      })
      .addCase(fetchLatestJobListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export const selectLatestJobList = (state) => state.latestJobList.data;

export default LatestJobListSlice.reducer;
